import { c as _c } from "react/compiler-runtime";
import { ComponentProps } from 'react';
import styled, { css, useTheme } from 'styled-components';
import { SpacingGridMultiple } from '@hookdeck/theme';
import { Div, StyledUtilsProps } from '../helpers/StyledUtils';
import { ThreeDEyeDarkIcon, ThreeDEyeLightIcon } from './icons/3dEye';
import { AdyenLightIcon } from './icons/Adyen';
import { AirwallexLightIcon } from './icons/Airwallex';
import { AkeneoLightIcon } from './icons/Akeneo';
import { AgentIcon } from './icons/Agent';
import { AscendDarkIcon, AscendLightIcon } from './icons/Ascend';
import { ArrowInIcon } from './icons/ArrowIn';
import { AWSS3LightIcon } from './icons/AWSS3';
import { AWSSNSLightIcon } from './icons/AWSSNS';
import { AWSSQSLightIcon } from './icons/AWSSQS';
import { AzureServiceBusLightIcon } from './icons/AzureServiceBus';
import { BondsmithLightIcon } from './icons/Bondsmith';
import { ClaudeLightIcon } from './icons/Claude';
import { CloudsignalsLightIcon } from './icons/Cloudsignals';
import { CommercelayerLightIcon } from './icons/Commercelayer';
import { CourierLightIcon } from './icons/Courier';
import { CustomerioLightIcon } from './icons/Customerio';
import { EventsLightIcon } from './icons/Events';
import { FacebookLightIcon } from './icons/Facebook';
import { FiservLightIcon } from './icons/Fiserv';
import { FrontappLightIcon } from './icons/Frontapp';
import { GitHubIcon } from './icons/GitHub';
import { GitLabLightIcon } from './icons/GitLab';
import { GCPPubSubLightIcon } from './icons/GCPPubSub';
import { GeminiDarkIcon, GeminiLightIcon } from './icons/Gemini';
import { GocardlessLightIcon } from './icons/Gocardless';
import { HubSpotLightIcon } from './icons/HubSpot';
import { LinearLightIcon } from './icons/Linear';
import { MailgunLightIcon } from './icons/Mailgun';
import { OuraLightIcon } from './icons/Oura';
import { PersonaLightIcon } from './icons/Persona';
import { PipedriveLightIcon } from './icons/Pipedrive';
import { PostmarkLightIcon } from './icons/Postmark';
import { PraxisLightIcon } from './icons/Praxis';
import { PropertyFinderLightIcon } from './icons/PropertyFinder';
import { PylonLightIcon } from './icons/Pylon';
import { RabbitMQLightIcon } from './icons/RabbitMQ';
import { RazorpayLightIcon } from './icons/Razorpay';
import { RechargeLightIcon } from './icons/Recharge';
import { RepayLightIcon } from './icons/Repay';
import { ReplicateLightIcon } from './icons/Replicate';
import { RequestLightIcon } from './icons/Request';
import { RequestLinkIcon } from './icons/RequestLink';
import { SanityLightIcon } from './icons/Sanity';
import { SendgridLightIcon } from './icons/Sendgrid';
import { ShoplineLightIcon } from './icons/Shopline';
import { SlackLightIcon } from './icons/Slack';
import { SmartcarLightIcon, SmartcarDarkIcon } from './icons/Smartcar';
import { SolidgateLightIcon } from './icons/Solidgate';
import { SquareLightIcon } from './icons/Square';
import { StripeLightIcon } from './icons/Stripe';
import { SvixLightIcon } from './icons/Svix';
import { SyncteraLightIcon } from './icons/Synctera';
import { TebexLightIcon } from './icons/Tebex';
import { TelnyxLightIcon } from './icons/Telnyx';
import { TikTokShopLightIcon } from './icons/TikTokShop';
import { TikTokLightIcon } from './icons/TikTok';
import { TokenioLightIcon } from './icons/Tokenio';
import { TreezorLightIcon } from './icons/Treezor';
import { TwitchLightIcon } from './icons/Twitch';
import { VercelLightIcon } from './icons/Vercel';
import { WhatsAppLightIcon } from './icons/WhatsApp';
import { WixLightIcon } from './icons/Wix';
import { XLightIcon } from './icons/X';
import { ZendeskDarkIcon, ZendeskLightIcon } from './icons/Zendesk';
export const svg_icons = {
  loading: () => <svg viewBox="0 0 120 30" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15">
        <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite" />
        <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite" />
      </circle>
      <circle cx="60" cy="15" r="9" fillOpacity="0.3">
        <animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite" />
        <animate attributeName="fill-opacity" from="0.5" to="0.5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite" />
      </circle>
      <circle cx="105" cy="15" r="15">
        <animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite" />
        <animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite" />
      </circle>
    </svg>,
  slack_colored: () => <>
      <path d="M6.78194 14.375C6.78194 15.4158 5.93174 16.266 4.89097 16.266C3.8502 16.266 3 15.4158 3 14.375C3 13.3343 3.8502 12.4841 4.89097 12.4841H6.78194V14.375Z" fill="#E01E5A" />
      <path d="M7.73633 14.375C7.73633 13.3343 8.58653 12.4841 9.6273 12.4841C10.6681 12.4841 11.5183 13.3343 11.5183 14.375V19.1098C11.5183 20.1506 10.6681 21.0008 9.6273 21.0008C8.58653 21.0008 7.73633 20.1506 7.73633 19.1098V14.375Z" fill="#E01E5A" />
      <path d="M9.6273 6.78194C8.58653 6.78194 7.73633 5.93174 7.73633 4.89097C7.73633 3.8502 8.58653 3 9.6273 3C10.6681 3 11.5183 3.8502 11.5183 4.89097V6.78194H9.6273Z" fill="#36C5F0" />
      <path d="M9.62572 7.73474C10.6665 7.73474 11.5167 8.58494 11.5167 9.62571C11.5167 10.6665 10.6665 11.5167 9.62572 11.5167H4.89097C3.8502 11.5167 3 10.6665 3 9.62571C3 8.58494 3.8502 7.73474 4.89097 7.73474H9.62572Z" fill="#36C5F0" />
      <path d="M17.2227 9.62571C17.2227 8.58494 18.0729 7.73474 19.1136 7.73474C20.1544 7.73474 21.0046 8.58494 21.0046 9.62571C21.0046 10.6665 20.1544 11.5167 19.1136 11.5167H17.2227V9.62571Z" fill="#2EB67D" />
      <path d="M16.2683 9.62572C16.2683 10.6665 15.4181 11.5167 14.3773 11.5167C13.3365 11.5167 12.4863 10.6665 12.4863 9.62572V4.89097C12.4863 3.8502 13.3365 3 14.3773 3C15.4181 3 16.2683 3.8502 16.2683 4.89097V9.62572Z" fill="#2EB67D" />
      <path d="M14.3773 17.2189C15.4181 17.2189 16.2683 18.0691 16.2683 19.1099C16.2683 20.1507 15.4181 21.0009 14.3773 21.0009C13.3365 21.0009 12.4863 20.1507 12.4863 19.1099V17.2189H14.3773Z" fill="#ECB22E" />
      <path d="M14.3773 16.2661C13.3365 16.2661 12.4863 15.4159 12.4863 14.3752C12.4863 13.3344 13.3365 12.4842 14.3773 12.4842H19.112C20.1528 12.4842 21.003 13.3344 21.003 14.3752C21.003 15.4159 20.1528 16.2661 19.112 16.2661H14.3773Z" fill="#ECB22E" />
    </>,
  doppler_colored: () => <>
      <defs xmlns="http://www.w3.org/2000/svg">
        <linearGradient id="paint0_linear_610_1042" x1="71.835" x2="8.2341" y1="-2.9931" y2="82.312" gradientUnits="userSpaceOnUse">
          <stop stopColor="#409FF8" offset=".036458" />
          <stop stopColor="#1673FF" offset=".5" />
          <stop stopColor="#516FF7" offset="1" />
        </linearGradient>
      </defs>
      <g xmlns="http://www.w3.org/2000/svg" transform="scale(.26667)" fill="none">
        <path d="m1.6523 0c-0.71885 0-1.1446 0.79424-0.7576 1.4l16.135 25.255c1.3343 2.0885 3.6346 3.3524 6.113 3.3524h21.824c7.9991 0 13 7.0729 12.97 14.992s-5.3582 14.922-12.97 14.922h-23.3c-1.3369 0-2.4157 1.0838-2.4157 2.4208v25.239c0 1.3356 1.0765 2.4182 2.412 2.4182h29.764c25.754 0 38.557-24.434 38.573-45s-12.638-45-38.573-45zm10.586 59.992h-5.7943c-3.5591 0-6.4443 3.3575-6.4443 7.4991v21.847c0 0.359 0.29103 0.6501 0.65004 0.6501h5.7943c3.5591 0 6.4443-3.3575 6.4443-7.4991v-21.847c0-0.359-0.291-0.6501-0.65-0.6501z" clipRule="evenodd" fill="url(#paint0_linear_610_1042)" fillRule="evenodd" />
      </g>
    </>,
  datadog: () => <>
      <path fillRule="evenodd" clipRule="evenodd" d="M18.7491 16.6185L16.9693 15.412L15.4845 17.9608L13.7577 17.4419L12.2373 19.8269L12.3152 20.5776L20.582 19.0122L20.1019 13.7038L18.7491 16.6185ZM11.0396 14.3298L12.3659 14.1423C12.5805 14.2414 12.7299 14.2792 12.9873 14.3465C13.388 14.4538 13.8519 14.5567 14.5389 14.2009C14.6988 14.1195 15.0319 13.8065 15.1665 13.6281L20.6008 12.6149L21.1552 19.5103L11.8453 21.2347L11.0396 14.3298ZM21.1342 11.8452L20.5978 11.9502L19.5672 1.00781L2.00781 3.10036L4.17108 21.142L6.22641 20.8354C6.06228 20.5946 5.8067 20.3032 5.37025 19.9301C4.76492 19.4133 4.97902 18.5354 5.33602 17.9811C5.80845 17.0444 8.24253 15.8541 8.10462 14.357C8.05516 13.8127 7.97096 13.104 7.4793 12.6185C7.46081 12.8201 7.49404 13.0142 7.49404 13.0142C7.49404 13.0142 7.29218 12.7494 7.1915 12.3885C7.09157 12.2501 7.01312 12.2059 6.90694 12.021C6.83125 12.2349 6.84124 12.4829 6.84124 12.4829C6.84124 12.4829 6.6761 12.0819 6.64937 11.7435C6.55144 11.895 6.52671 12.1828 6.52671 12.1828C6.52671 12.1828 6.3121 11.5507 6.36107 11.2102C6.26314 10.9139 5.97284 10.3259 6.05503 8.98954C6.59091 9.37544 7.7706 9.28378 8.23028 8.58746C8.38293 8.35689 8.48736 7.72733 8.15409 6.48695C7.93998 5.69153 7.40985 4.50712 7.20324 4.0578L7.17851 4.07603C7.28743 4.43805 7.51203 5.19702 7.59822 5.56495C7.85904 6.68106 7.92899 7.06953 7.80658 7.58406C7.7024 8.03133 7.45257 8.32403 6.81926 8.65113C6.18594 8.97927 5.34552 8.18076 5.2923 8.1366C4.67698 7.63285 4.20105 6.81098 4.14784 6.41172C4.09263 5.97473 4.39292 5.71232 4.54432 5.35492C4.32772 5.4186 4.08613 5.53157 4.08613 5.53157C4.08613 5.53157 4.37444 5.225 4.72994 4.95978C4.87709 4.85964 4.96353 4.79597 5.11867 4.66348C4.89408 4.65963 4.7117 4.66631 4.7117 4.66631C4.7117 4.66631 5.0862 4.45833 5.47443 4.30685C5.19037 4.29401 4.91856 4.3048 4.91856 4.3048C4.91856 4.3048 5.75424 3.92069 6.41428 3.63877C6.86822 3.44749 7.31167 3.50398 7.56075 3.87422C7.88777 4.35923 8.23128 4.62266 8.95928 4.78595C9.40623 4.58235 9.54213 4.47759 10.1037 4.32046C10.5982 3.76176 10.9864 3.68936 10.9864 3.68936C10.9864 3.68936 10.7938 3.87088 10.7423 4.15614C11.0226 3.92916 11.3299 3.73968 11.3299 3.73968C11.3299 3.73968 11.211 3.89065 11.1001 4.13046L11.1258 4.16974C11.4528 3.96819 11.8373 3.80926 11.8373 3.80926C11.8373 3.80926 11.7274 3.95202 11.5985 4.13688C11.8451 4.13482 12.3452 4.14766 12.5393 4.17026C13.6853 4.19619 13.9231 2.91242 14.3628 2.75143C14.9134 2.54937 15.1595 2.42715 16.0979 3.37432C16.9031 4.18746 17.5321 5.643 17.2199 5.96908C16.958 6.2397 16.4414 5.86355 15.8688 5.13C15.5662 4.74154 15.3374 4.28246 15.2302 3.69886C15.1398 3.2064 14.7878 2.92063 14.7878 2.92063C14.7878 2.92063 14.9921 3.38741 14.9921 3.79976C14.9921 4.02493 15.0196 4.86683 15.3709 5.33926C15.3361 5.40833 15.3199 5.681 15.2814 5.73312C14.8727 5.22552 13.9951 4.86221 13.8519 4.75514C14.3363 5.16313 15.4498 6.10028 15.8775 6.99841C16.282 7.84775 16.0437 8.62623 16.2483 8.82778C16.3065 8.88555 17.1182 9.92489 17.2743 10.4471C17.5466 11.3573 17.2906 12.3137 16.9341 12.9071L15.9385 13.0665C15.7928 13.0249 15.6947 13.0041 15.564 12.9264C15.6359 12.7954 15.7791 12.4688 15.7806 12.4015L15.7244 12.3001C15.4146 12.7512 14.8955 13.1893 14.4643 13.4409C13.8999 13.7695 13.2493 13.719 12.8259 13.5842C11.624 13.2031 10.4875 12.3684 10.2134 12.1492C10.2134 12.1492 10.2049 12.3243 10.2566 12.3635C10.5597 12.7148 11.254 13.3503 11.925 13.7932L10.4945 13.9549L11.1708 19.3668C10.871 19.4109 10.8243 19.4325 10.496 19.4805C10.2067 18.4301 9.65331 17.7443 9.04847 17.3448C8.51509 16.9926 7.77935 16.9132 7.07508 17.0565L7.02986 17.1104C7.51952 17.058 8.09763 17.131 8.69147 17.5174C9.27432 17.8961 9.744 18.8743 9.91688 19.4633C10.1382 20.2161 10.2914 21.0213 9.69553 21.8748C9.27157 22.4815 8.03392 22.8168 7.03411 22.0915C7.30117 22.5328 7.66218 22.8938 8.14809 22.9619C8.8696 23.0625 9.55438 22.9339 10.0258 22.4365C10.4283 22.0113 10.6416 21.1222 10.5854 20.1858L11.2222 20.0908L11.4521 21.7715L21.9943 20.467L21.1342 11.8452ZM14.7203 7.28084C14.6908 7.3499 14.6446 7.39509 14.7141 7.61975L14.7183 7.63259L14.7293 7.6616L14.7583 7.72887C14.8835 7.99179 15.0209 8.23981 15.2505 8.36639C15.3099 8.35612 15.3714 8.34919 15.4351 8.34585C15.6507 8.3361 15.7868 8.37127 15.8733 8.41903C15.881 8.37487 15.8828 8.31016 15.878 8.21491C15.8613 7.8819 15.9422 7.3155 15.3194 7.01741C15.0843 6.9052 14.7546 6.93987 14.6446 7.0798C14.6646 7.08236 14.6826 7.08673 14.6966 7.09161C14.8627 7.15143 14.7501 7.21023 14.7203 7.28084ZM16.4659 10.3881C16.3842 10.3419 16.0024 10.3601 15.7341 10.393C15.223 10.4548 14.6711 10.6371 14.5502 10.7342C14.3303 10.9088 14.4303 11.2133 14.5927 11.3383C15.0481 11.688 15.4473 11.9224 15.8688 11.8654C16.1276 11.8305 16.3557 11.4094 16.5173 11.0274C16.628 10.7642 16.628 10.4803 16.4659 10.3881ZM11.9405 7.69318C12.0846 7.55248 11.2225 7.36762 10.5534 7.83645C10.06 8.1823 10.0443 8.92381 10.5167 9.34412C10.5639 9.38571 10.6029 9.41524 10.6394 9.43937C10.7773 9.37261 10.9344 9.30509 11.1153 9.24475C11.4208 9.14282 11.6749 9.09018 11.8838 9.0622C11.9837 8.94743 12.0999 8.74536 12.0709 8.37949C12.0314 7.88318 11.6654 7.96201 11.9405 7.69318Z" fill="#632CA6" />
    </>,
  prometheus: () => <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill="#E6522C" d="M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12s12-5.373 12-12c0-6.628-5.373-12-12-12zm0 22.46c-1.885 0-3.414-1.26-3.414-2.814h6.828c0 1.553-1.528 2.813-3.414 2.813zm5.64-3.745H6.36v-2.046h11.28v2.046zm-.04-3.098H6.391c-.037-.043-.075-.086-.111-.13-1.155-1.401-1.427-2.133-1.69-2.879-.005-.025 1.4.287 2.395.511 0 0 .513.119 1.262.255-.72-.843-1.147-1.915-1.147-3.01 0-2.406 1.845-4.508 1.18-6.207.648.053 1.34 1.367 1.387 3.422.689-.951.977-2.69.977-3.755 0-1.103.727-2.385 1.454-2.429-.648 1.069.168 1.984.894 4.256.272.854.237 2.29.447 3.201.07-1.892.395-4.652 1.595-5.605-.529 1.2.079 2.702.494 3.424.671 1.164 1.078 2.047 1.078 3.716a4.642 4.642 0 01-1.11 2.996c.792-.149 1.34-.283 1.34-.283l2.573-.502s-.374 1.538-1.81 3.019z" />
    </svg>,
  dynatrace: () => <svg role="img" viewBox="0 0 73 73" xmlns="http://www.w3.org/2000/svg">
      <path d="M24.736 6.39229C23.83 11.1739 22.7227 18.2708 22.1187 25.4684C21.0617 38.1523 21.716 46.6585 21.716 46.6585L3.84787 63.6207C3.84787 63.6207 2.48888 54.1078 1.78422 43.3869C1.38156 36.743 1.23056 30.9044 1.23056 27.3811C1.23056 27.1797 1.33123 26.9784 1.33123 26.7771C1.33123 26.5254 1.63322 24.1598 3.94853 21.9451C6.46517 19.5291 25.038 4.98297 24.736 6.39229Z" fill="#1496FF" />
      <path d="M24.736 6.39226C23.83 11.1739 22.7227 18.2708 22.1187 25.4684C22.1187 25.4684 2.33788 23.1028 1.23056 27.8844C1.23056 27.6327 1.58289 24.7134 3.8982 22.4988C6.41484 20.0828 25.038 4.98294 24.736 6.39226Z" fill="#1284EA" />
      <path d="M1.23057 26.7267C1.23057 27.0791 1.23057 27.4314 1.23057 27.834C1.4319 26.9784 1.78423 26.3744 2.48889 25.4181C3.94854 23.5558 6.31418 23.0524 7.2705 22.9518C12.1025 22.2974 19.2497 21.5424 26.4473 21.3411C39.1815 20.9385 47.5871 21.9954 47.5871 21.9954L65.4552 5.03329C65.4552 5.03329 56.0933 3.27164 45.4228 2.01332C38.4265 1.15766 32.2859 0.70467 28.8129 0.503339C28.5613 0.503339 26.095 0.201342 23.7797 2.41598C21.263 4.83196 8.47849 16.9622 3.34455 21.8444C1.02924 24.0591 1.23057 26.5254 1.23057 26.7267Z" fill="#B4DC00" />
      <path d="M64.8009 48.4202C59.9689 49.0745 52.8217 49.8798 45.6241 50.1315C32.8899 50.5341 24.434 49.4771 24.434 49.4771L6.56584 66.4896C6.56584 66.4896 16.0284 68.3519 26.699 69.5599C33.2422 70.3149 39.0305 70.7176 42.5538 70.9189C42.8055 70.9189 43.2081 70.7176 43.4598 70.7176C43.7114 70.7176 46.1777 70.2646 48.4931 68.0499C51.0097 65.634 66.2102 48.2692 64.8009 48.4202Z" fill="#6F2DA8" />
      <path d="M64.8009 48.4202C59.969 49.0745 52.8217 49.8798 45.6241 50.1315C45.6241 50.1315 46.9831 70.0129 42.2015 70.8686C42.4531 70.8686 45.7248 70.7176 48.0401 68.503C50.5567 66.087 66.2102 48.2692 64.8009 48.4202Z" fill="#591F91" />
      <path d="M43.2584 70.9693C42.9061 70.9693 42.5538 70.9189 42.1511 70.9189C43.0571 70.7679 43.6611 70.4659 44.6174 69.7613C46.5301 68.4023 47.1341 66.0367 47.3354 65.0803C48.1911 60.2987 49.3487 53.2018 49.9024 46.0042C50.909 33.3203 50.305 24.8644 50.305 24.8644L68.1732 7.85194C68.1732 7.85194 69.4818 17.3145 70.2368 28.0354C70.6898 35.0317 70.8408 41.2226 70.8911 44.6452C70.8911 44.8969 71.0925 47.3632 68.7772 49.5778C66.2605 51.9938 53.476 64.1743 48.3924 69.0566C45.9764 71.2713 43.5101 70.9693 43.2584 70.9693Z" fill="#73BE28" />
    </svg>,
  new_relic: ({
    theme
  }: {
    theme: {
      mode: string;
    };
  }) => {
    const dark_fill = theme?.mode === 'dark' ? '#ffffff' : '#1d252c';
    return <svg viewBox="0 0 832.8 959.8">
        <path d="M672.6 332.3l160.2-92.4v480L416.4 959.8V775.2l256.2-147.6z" fill="#00ac69" />
        <path d="M416.4 184.6L160.2 332.3 0 239.9 416.4 0l416.4 239.9-160.2 92.4z" fill="#1ce783" />
        <path d="M256.2 572.3L0 424.6V239.9l416.4 240v479.9l-160.2-92.2z" fill={dark_fill} />
      </svg>;
  },
  opsgenie_colored: () => <>
      <path d="M12 12C15.3137 12 18 9.3137 18 5.99998C18 2.68628 15.3137 0 12 0C8.68629 0 6 2.68628 6 5.99998C6 9.3137 8.68629 12 12 12Z" fill="url(#paint0_linear_3580_69212)" />
      <path d="M11.2255 23.8474C7.46232 21.4108 4.3155 18.0852 2.07706 14.134C1.91485 13.8046 2.01217 13.4095 2.33658 13.2449H2.36902L6.74856 11.0717C7.04057 10.9071 7.42986 11.0388 7.59205 11.3352C9.79805 15.0888 13.0747 18.1181 17 19.9621C15.5726 21.4437 13.9505 22.7609 12.2312 23.8804C11.9067 24.045 11.5174 24.045 11.2255 23.8474Z" fill="url(#paint1_linear_3580_69212)" />
      <path d="M12.1595 23.8474C16.1736 21.4108 19.5301 18.0852 21.9178 14.134C22.0908 13.8046 21.987 13.4095 21.641 13.2449H21.6063L16.9348 11.0717C16.6234 10.9071 16.2082 11.0388 16.0351 11.3352C13.6821 15.0888 10.1871 18.1181 6 19.9621C7.52259 21.4437 9.25271 22.7609 11.0868 23.8804C11.4328 24.045 11.848 24.045 12.1595 23.8474Z" fill="#2684FF" />
      <defs>
        <linearGradient id="paint0_linear_3580_69212" x1="12.0026" y1="1.98654" x2="12.0026" y2="14.3238" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2684FF" />
          <stop offset="0.82" stopColor="#0052CC" />
        </linearGradient>
        <linearGradient id="paint1_linear_3580_69212" x1="8.15183" y1="14.1242" x2="12.2264" y2="22.526" gradientUnits="userSpaceOnUse">
          <stop stopColor="#2684FF" />
          <stop offset="0.62" stopColor="#0052CC" />
        </linearGradient>
      </defs>
    </>,
  pagerduty: () => <path fill="#06AC38" d="M16.965 1.18C15.085.164 13.769 0 10.683 0H3.73v14.55h6.926c2.743 0 4.8-.164 6.61-1.37 1.975-1.303 3.004-3.484 3.004-6.007 0-2.716-1.262-4.896-3.305-5.994zm-5.5 10.326h-4.21V3.113l3.977-.027c3.62-.028 5.43 1.234 5.43 4.128 0 3.113-2.248 4.292-5.197 4.292zM3.73 17.61h3.525V24H3.73Z" />,
  // Official Sentry glyph (72x66 artwork without its padding), scaled to fit the 24x24 box.
  sentry: ({
    theme
  }: {
    theme: {
      mode: string;
    };
  }) => <path transform="translate(0 1.44) scale(0.48)" fill={theme?.mode === 'dark' ? '#FFFFFF' : '#181225'} d="M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z" />,
  folder_private: () => <>
      <path d="M4.19941 19.1999C3.71608 19.1999 3.29525 19.0236 2.93691 18.6709C2.57858 18.3183 2.39941 17.8943 2.39941 17.3989V6.59293C2.39941 6.09759 2.57525 5.67493 2.92691 5.32493C3.27841 4.97493 3.70108 4.79993 4.19491 4.79993H8.84041C9.07975 4.79993 9.30775 4.84159 9.52441 4.92493C9.74108 5.00826 9.94108 5.14159 10.1244 5.32493L11.9994 7.19993H19.7994C20.2944 7.19993 20.7182 7.37618 21.0707 7.72868C21.4232 8.08118 21.5994 8.50493 21.5994 8.99993C21.5994 9.25493 21.5137 9.46868 21.3422 9.64118C21.1707 9.81368 20.9582 9.89993 20.7047 9.89993C20.4512 9.89993 20.2369 9.81368 20.0619 9.64118C19.8869 9.46868 19.7994 9.25493 19.7994 8.99993H11.2494L8.84941 6.59993H4.19941V17.3999L11.9994 17.3989C12.2544 17.3989 12.4682 17.4847 12.6407 17.6562C12.8132 17.8277 12.8994 18.0402 12.8994 18.2937C12.8994 18.5472 12.8132 18.7614 12.6407 18.9364C12.4682 19.1114 12.2544 19.1989 11.9994 19.1989L4.19941 19.1999Z" fill="currentColor" />
      <path d="M15.127 21.8857C14.8794 21.8857 14.6718 21.802 14.5042 21.6344C14.3367 21.4669 14.2529 21.2593 14.2529 21.0116V15.7669C14.2529 15.5241 14.3379 15.3117 14.5079 15.1295C14.6778 14.9474 14.8842 14.8685 15.127 14.8928H16.0012V13.1446C16.0012 12.4234 16.2587 11.8061 16.7737 11.2925C17.2887 10.779 17.9078 10.5222 18.6312 10.5222C19.3545 10.5222 19.9711 10.779 20.481 11.2925C20.9909 11.8061 21.2459 12.4234 21.2459 13.1446V14.8928H22.12C22.3677 14.8928 22.5753 14.9766 22.7428 15.1441C22.9103 15.3117 22.9941 15.5193 22.9941 15.7669V21.0116C22.9941 21.2593 22.9103 21.4669 22.7428 21.6344C22.5753 21.802 22.3677 21.8857 22.12 21.8857H15.127ZM17.3123 14.8928H19.9347V13.1446C19.9347 12.7731 19.8098 12.4617 19.5599 12.2104C19.3101 11.959 19.0005 11.8334 18.6312 11.8334C18.2619 11.8334 17.9497 11.959 17.6948 12.2104C17.4398 12.4617 17.3123 12.7731 17.3123 13.1446V14.8928Z" fill="currentColor" />
    </>
};
export const public_icons = {
  asana: '/icons/asana.png',
  coinbase: '/icons/coinbase.png',
  cursor: {
    dark: '/icons/cursor-light.png',
    light: '/icons/cursor.png'
  },
  example: '/icons/example.svg',
  shopify: '/icons/shopify.png',
  bridge: '/icons/bridge.png',
  clickpost: '/icons/clickpost.png',
  rebilly: '/icons/rebilly.png',
  honeycomb: '/icons/honeycomb.png',
  soniox: '/icons/soniox.png',
  digital_samba: '/icons/digital_samba.png',
  argo_cd: '/icons/argo_cd.png',
  connecteam: '/icons/connecteam.png',
  arcadia: '/icons/arcadia.png',
  govuk_notify: '/icons/govuk_notify.png',
  measureone: '/icons/measureone.png',
  mono: '/icons/mono.png',
  swan: '/icons/swan.png',
  payrix_pro: '/icons/payrix_pro.png',
  harbor: '/icons/harbor.png',
  vellum: '/icons/vellum.svg',
  estuary: '/icons/estuary.png',
  hundred_ms: '/icons/hundred_ms.png',
  navattic: {
    light: '/icons/navattic.png',
    dark: '/icons/navattic-light.png'
  },
  gumlet: '/icons/gumlet.png',
  gc_notify: '/icons/gc_notify.png',
  payjp: '/icons/payjp.png',
  tabby: '/icons/tabby.png',
  payroc: '/icons/payroc.png',
  trendyol: '/icons/trendyol.png',
  plunk: {
    light: '/icons/plunk.svg',
    dark: '/icons/plunk-light.svg'
  },
  smtp2go: '/icons/smtp2go.png',
  clickatell: '/icons/clickatell.png',
  kibana: '/icons/kibana.png',
  rebrandly: '/icons/rebrandly.png',
  particle: '/icons/particle.png',
  aurora_solar: '/icons/aurora_solar.png',
  palmetto_finance: '/icons/palmetto_finance.png',
  ship24: '/icons/ship24.png',
  zoop: '/icons/zoop.png',
  celcoin: '/icons/celcoin.png',
  leonardo_ai: '/icons/leonardo_ai.png',
  sevalla: '/icons/sevalla.png',
  sublime_security: '/icons/sublime_security.png',
  firstpromoter: {
    light: '/icons/firstpromoter.png',
    dark: '/icons/firstpromoter-light.png'
  },
  mighty_networks: '/icons/mighty_networks.png',
  hostaway: '/icons/hostaway.png',
  incode: '/icons/incode.png',
  datacake: '/icons/datacake.png',
  ventrata: '/icons/ventrata.png',
  discord: '/icons/discord.png',
  enode: '/icons/enode.png',
  elevenlabs: {
    light: '/icons/elevenlabs.svg',
    dark: '/icons/elevenlabs-light.svg'
  },
  favro: '/icons/favro.png',
  fusionauth: {
    dark: '/icons/fusionauth-light.png',
    light: '/icons/fusionauth.png'
  },
  nmi: '/icons/nmi.png',
  paypal: '/icons/paypal.png',
  portal_locks: '/icons/portal_locks.png',
  upollo: '/icons/upollo.png',
  ebay: '/icons/ebay.png',
  intercom: '/icons/intercom.png',
  belco: '/icons/belco.png',
  hyperswitch: '/icons/hyperswitch.png',
  onramper: '/icons/onramper.png',
  qonto: '/icons/qonto.png',
  ziina: '/icons/ziina.png',
  spacelift: '/icons/spacelift.png',
  langfuse: '/icons/langfuse.png',
  optimizely: '/icons/optimizely.png',
  convox: {
    light: '/icons/convox.png',
    dark: '/icons/convox-light.png'
  },
  rewardful: '/icons/rewardful.png',
  referralhero: {
    light: '/icons/referralhero.png',
    dark: '/icons/referralhero-light.png'
  },
  fountain: '/icons/fountain.png',
  storylane: '/icons/storylane.png',
  terra_api: '/icons/terra_api.png',
  katana: '/icons/katana.png',
  oxapay: '/icons/oxapay.png',
  returnless: '/icons/returnless.png',
  bvnk: '/icons/bvnk.png',
  pulumi: '/icons/pulumi.png',
  agora: '/icons/agora.png',
  mailcoach: {
    light: '/icons/mailcoach.png',
    dark: '/icons/mailcoach-light.png'
  },
  chameleon: '/icons/chameleon.png',
  taskade: '/icons/taskade.png',
  complycube: '/icons/complycube.png',
  api_video: '/icons/api_video.png',
  checkout_page: {
    light: '/icons/checkout_page.png',
    dark: '/icons/checkout_page-light.png'
  },
  khipu: '/icons/khipu.png',
  rootfi: '/icons/rootfi.png',
  column: '/icons/column.png',
  sonarqube: '/icons/sonarqube.png',
  baseten: '/icons/baseten.png',
  flux_cd: '/icons/flux_cd.png',
  argyle: {
    light: '/icons/argyle.png',
    dark: '/icons/argyle-light.png'
  },
  meetgeek: '/icons/meetgeek.png',
  idenfy: '/icons/idenfy.png',
  thinkific: {
    light: '/icons/thinkific.png',
    dark: '/icons/thinkific-light.png'
  },
  socotra: '/icons/socotra.png',
  proof: '/icons/proof.png',
  creem: {
    light: '/icons/creem.png',
    dark: '/icons/creem-light.png'
  },
  komoju: {
    light: '/icons/komoju.png',
    dark: '/icons/komoju-light.png'
  },
  paypercut: '/icons/paypercut.png',
  terminal49: '/icons/terminal49.png',
  cryptoprocessing: '/icons/cryptoprocessing.png',
  forgejo: '/icons/forgejo.png',
  wistia: '/icons/wistia.png',
  convex: '/icons/convex.png',
  learnupon: '/icons/learnupon.png',
  surveymethods: {
    light: '/icons/surveymethods.png',
    dark: '/icons/surveymethods-light.png'
  },
  partnero: '/icons/partnero.png',
  northpass: '/icons/northpass.png',
  texture: '/icons/texture.png',
  mailchimp: '/icons/mailchimp.png',
  orb: {
    dark: '/icons/orb-light.png',
    light: '/icons/orb.png'
  },
  zoom: '/icons/zoom.png',
  xero: '/icons/xero.png',
  woocommerce: '/icons/woocommerce.png',
  workos: '/icons/workos.png',
  trello: '/icons/trello.png',
  twilio: '/icons/twilio.png',
  treezor: '/icons/treezor.png',
  paddle: '/icons/paddle.png',
  bigcommerce: '/icons/bigcommerce.png',
  smile: '/icons/smile.png',
  linkedin: '/icons/linkedin.png',
  docusign: '/icons/docusign.png',
  fireblocks: {
    dark: '/icons/fireblocks-light.png',
    light: '/icons/fireblocks.png'
  },
  strava: '/icons/strava.png',
  aiprise: '/icons/aiprise.png',
  delivereasy: '/icons/delivereasy.png',
  loyaltylion: '/icons/loyaltylion.png',
  payt: '/icons/payt.png',
  semaphore: {
    light: '/icons/semaphore.png',
    dark: '/icons/semaphore-light.png'
  },
  uploadcare: '/icons/uploadcare.png',
  oh_dear: '/icons/oh_dear.png',
  lettermint: '/icons/lettermint.png',
  buttondown: '/icons/buttondown.png',
  opnform: '/icons/opnform.png',
  qlik_cloud: '/icons/qlik_cloud.png',
  reditus: '/icons/reditus.png',
  tutorcruncher: {
    light: '/icons/tutorcruncher.png',
    dark: '/icons/tutorcruncher-light.png'
  },
  hint_health: '/icons/hint_health.png',
  high_mobility: '/icons/high_mobility.png',
  deliverect: '/icons/deliverect.png',
  memberful: {
    light: '/icons/memberful.png',
    dark: '/icons/memberful-light.png'
  },
  paytabs: '/icons/paytabs.png',
  treet: '/icons/treet.png',
  felloh: '/icons/felloh.png',
  planetscale: {
    light: '/icons/planetscale.png',
    dark: '/icons/planetscale-light.png'
  },
  plane: '/icons/plane.png',
  agentset: '/icons/agentset.png',
  xtremepush: '/icons/xtremepush.png',
  bump_sh: {
    light: '/icons/bump_sh.png',
    dark: '/icons/bump_sh-light.png'
  },
  ayrshare: '/icons/ayrshare.png',
  morta: '/icons/morta.png',
  sendx: '/icons/sendx.png',
  dojah: '/icons/dojah.png',
  teachfloor: '/icons/teachfloor.png',
  spike_api: {
    light: '/icons/spike_api.png',
    dark: '/icons/spike_api-light.png'
  },
  top_gg: '/icons/top_gg.png',
  freemius: '/icons/freemius.png',
  mews_pos: '/icons/mews_pos.png',
  violet: '/icons/violet.png',
  logto: '/icons/logto.png',
  hackerone: '/icons/hackerone.png',
  cloudsmith: '/icons/cloudsmith.png',
  kolide: '/icons/kolide.png',
  zitadel: '/icons/zitadel.png',
  tokity: '/icons/tokity.png',
  bigmailer: '/icons/bigmailer.png',
  formspree: '/icons/formspree.png',
  learnhouse: '/icons/learnhouse.png',
  sahha: '/icons/sahha.png',
  hifi: '/icons/hifi.png',
  preczn: {
    light: '/icons/preczn.png',
    dark: '/icons/preczn-light.png'
  },
  ryft: '/icons/ryft.png',
  authgear: '/icons/authgear.png',
  fingerprint: '/icons/fingerprint.png',
  gitbook: '/icons/gitbook.png',
  dub: {
    light: '/icons/dub.png',
    dark: '/icons/dub-light.png'
  },
  uppromote: '/icons/uppromote.png',
  thought_industries: '/icons/thought_industries.png',
  survicate: '/icons/survicate.png',
  medplum: '/icons/medplum.png',
  vivenu: '/icons/vivenu.png',
  root_platform: '/icons/root_platform.png',
  govuk_pay: '/icons/govuk_pay.png',
  polar: {
    dark: '/icons/polar.png',
    light: '/icons/polar-dark.png'
  },
  storekit: '/icons/storekit.png',
  skovik: '/icons/skovik.png',
  prividium: '/icons/prividium.png',
  dodo_payments: '/icons/dodo_payments.png',
  recurrente: {
    light: '/icons/recurrente.png',
    dark: '/icons/recurrente-light.png'
  },
  monerium: '/icons/monerium.png',
  salad_cloud: '/icons/salad_cloud.png',
  trackstar: '/icons/trackstar.png',
  runa: {
    light: '/icons/runa.png',
    dark: '/icons/runa-light.png'
  },
  axilio: '/icons/axilio.png',
  supertab: '/icons/supertab.png',
  helcim: '/icons/helcim.png',
  tolt: '/icons/tolt.png',
  superwall: '/icons/superwall.png',
  hirehive: '/icons/hirehive.png',
  justt: '/icons/justt.png',
  scalekit: '/icons/scalekit.png',
  pinata: '/icons/pinata.png',
  laso_finance: '/icons/laso_finance.png',
  chargeblast: '/icons/chargeblast.png',
  pipecat_cloud: {
    light: '/icons/pipecat_cloud.png',
    dark: '/icons/pipecat_cloud-light.png'
  },
  pganalyze: {
    light: '/icons/pganalyze.png',
    dark: '/icons/pganalyze-light.png'
  },
  dots: '/icons/dots.png',
  camel_ai: '/icons/camel_ai.png',
  salsa: {
    light: '/icons/salsa.png',
    dark: '/icons/salsa-light.png'
  },
  blindpay: '/icons/blindpay.png',
  goody: '/icons/goody.png',
  spacebring: '/icons/spacebring.png',
  hexclave: '/icons/hexclave.png',
  sajn: {
    light: '/icons/sajn.png',
    dark: '/icons/sajn-light.png'
  },
  origami: '/icons/origami.png',
  swipelux: '/icons/swipelux.png',
  travtus: '/icons/travtus.png',
  omnara: '/icons/omnara.png',
  layerswap: '/icons/layerswap.png',
  velt: '/icons/velt.png',
  argil: '/icons/argil.png',
  terminal_telematics: '/icons/terminal_telematics.png',
  tally: {
    light: '/icons/tally.svg',
    dark: '/icons/tally-light.png'
  },
  typeform: {
    dark: '/icons/typeform-light.png',
    light: '/icons/typeform.png'
  },
  hasura: '/icons/hasura.png',
  prefect: '/icons/prefect.png',
  kobotoolbox: '/icons/kobotoolbox.png',
  fireberry: {
    light: '/icons/fireberry.png',
    dark: '/icons/fireberry-light.png'
  },
  hightouch: '/icons/hightouch.png',
  onelogin: {
    light: '/icons/onelogin.png',
    dark: '/icons/onelogin-light.png'
  },
  paragon: '/icons/paragon.png',
  rev_ai: '/icons/rev_ai.png',
  stuart: '/icons/stuart.png',
  sigfox: '/icons/sigfox.png',
  nium: '/icons/nium.png',
  three_sixty_dialog: '/icons/three_sixty_dialog.png',
  bitrise: '/icons/bitrise.png',
  datocms: '/icons/datocms.png',
  iterable: {
    light: '/icons/iterable.png',
    dark: '/icons/iterable-light.png'
  },
  onespan: '/icons/onespan.png',
  parcellab: '/icons/parcellab.png',
  zuora: '/icons/zuora.png',
  aws_eventbridge: '/icons/aws_eventbridge.png',
  proxyclick: '/icons/proxyclick.png',
  braze: '/icons/braze.png',
  jumpcloud: {
    light: '/icons/jumpcloud.png',
    dark: '/icons/jumpcloud-light.png'
  },
  paxos: '/icons/paxos.png',
  rudderstack: '/icons/rudderstack.png',
  tray_io: '/icons/tray_io.png',
  copper: '/icons/copper.png',
  belvo: '/icons/belvo.png',
  pubnub: '/icons/pubnub.png',
  amplitude: '/icons/amplitude.png',
  bringg: '/icons/bringg.png',
  doordash_drive: '/icons/doordash_drive.png',
  make: '/icons/make.png',
  ory: '/icons/ory.png',
  socure: '/icons/socure.png',
  vtex: '/icons/vtex.png',
  currents: '/icons/currents.png',
  apify: '/icons/apify.png',
  builder_io: '/icons/builder_io.svg',
  fourkites: '/icons/fourkites.png',
  oyster: {
    light: '/icons/oyster.png',
    dark: '/icons/oyster-light.png'
  },
  project44: '/icons/project44.png',
  speechmatics: '/icons/speechmatics.png',
  workato: '/icons/workato.png',
  invoice_ninja: {
    light: '/icons/invoice_ninja.png',
    dark: '/icons/invoice_ninja-light.png'
  },
  formio: {
    light: '/icons/formio.png',
    dark: '/icons/formio-light.png'
  },
  workspace_one: {
    light: '/icons/workspace_one.png',
    dark: '/icons/workspace_one-light.png'
  },
  azure_devops: '/icons/azure_devops.png',
  freshsales: '/icons/freshsales.png',
  omnisend: {
    light: '/icons/omnisend.png',
    dark: '/icons/omnisend-light.png'
  },
  paperform: {
    light: '/icons/paperform.png',
    dark: '/icons/paperform-light.png'
  },
  railway: '/icons/railway.png',
  strapi: '/icons/strapi.png',
  youcanbookme: '/icons/youcanbookme.png',
  okta: '/icons/okta.png',
  quoter: '/icons/quoter.png',
  meraki: '/icons/meraki.png',
  ringcentral: '/icons/ringcentral.png',
  monday: '/icons/monday.png',
  zerohash: '/icons/zerohash.png',
  microsoft_teams: '/icons/microsoft-teams.png',
  microsoft_graph: '/icons/microsoft-graph.png',
  microsoft_sharepoint: '/icons/microsoft-sharepoint.png',
  clio: {
    dark: '/icons/clio-light.png',
    light: '/icons/clio.png'
  },
  zift: '/icons/zift.svg',
  resend: {
    light: '/icons/resend.svg',
    dark: '/icons/resend-light.svg'
  },
  ethoca: '/icons/ethoca.png',
  airtable: '/icons/airtable.png',
  fastspring: '/icons/fastspring.png',
  'paypro-global': '/icons/paypro-global.png',
  lithic: {
    dark: '/icons/lithic-light.png',
    light: '/icons/lithic.png'
  },
  usps: '/icons/usps.png',
  exactonline: '/icons/exactonline.png',
  utila: {
    dark: '/icons/utila-light.png',
    light: '/icons/utila.png'
  },
  nuvemshop: '/icons/nuvemshop.png',
  nylas: '/icons/nylas.png',
  chargebee: '/icons/chargebee.png',
  nomod: '/icons/nomod.png',
  openlayer: '/icons/openlayer.png',
  sohar_health: '/icons/sohar_health.png',
  cerebrum: '/icons/cerebrum.png',
  airweave: {
    light: '/icons/airweave.png',
    dark: '/icons/airweave-light.png'
  },
  relay_messenger: '/icons/relay_messenger.png',
  nitrosend: '/icons/nitrosend.png',
  junction: '/icons/junction.png',
  agntix: '/icons/agntix.png',
  memos: '/icons/memos.png',
  cuuro: '/icons/cuuro.png',
  novu: '/icons/novu.png',
  bayou_energy: {
    light: '/icons/bayou_energy.png',
    dark: '/icons/bayou_energy-light.png'
  },
  celitech: '/icons/celitech.png',
  requesty: '/icons/requesty.png',
  speed: '/icons/speed.png',
  crossmint: '/icons/crossmint.png',
  tensorlake: '/icons/tensorlake.png',
  notifuse: {
    light: '/icons/notifuse.png',
    dark: '/icons/notifuse-light.png'
  },
  formbricks: '/icons/formbricks.png',
  meeting_baas: '/icons/meeting_baas.png',
  versive: '/icons/versive.png',
  webiny: '/icons/webiny.png',
  vern: {
    light: '/icons/vern.png',
    dark: '/icons/vern-light.png'
  },
  epilot: '/icons/epilot.png',
  voiceflow: '/icons/voiceflow.png',
  surge: '/icons/surge.png',
  nextpay: '/icons/nextpay.png',
  linq: '/icons/linq.png',
  pine_labs: {
    light: '/icons/pine_labs.png',
    dark: '/icons/pine_labs-light.png'
  },
  liveblocks: '/icons/liveblocks.png',
  privy: '/icons/privy.png',
  clemta: '/icons/clemta.png',
  flexprice: '/icons/flexprice.png',
  isnap: '/icons/isnap.png',
  globalstack: '/icons/globalstack.png',
  general_translation: '/icons/general_translation.png',
  trunk: '/icons/trunk.png',
  doubleword: '/icons/doubleword.png',
  outhire: '/icons/outhire.png',
  basiq: '/icons/basiq.png',
  bindbee: '/icons/bindbee.png',
  recurly: '/icons/recurly.png',
  openai: '/icons/openai.png',
  bridgeapi: '/icons/bridgeapi.png',
  picqer: '/icons/picqer.png',
  alipay: '/icons/alipay.png',
  bird: '/icons/bird.png',
  propelauth: '/icons/propelauth.png',
  mailerlite: '/icons/mailerlite.png',
  go1: '/icons/go1.png',
  terraform: {
    light: '/icons/terraform.png',
    dark: '/icons/terraform-light.png'
  },
  bland_ai: '/icons/bland_ai.png',
  gitea: '/icons/gitea.png',
  loop_returns: '/icons/loop_returns.png',
  codat: '/icons/codat.png',
  toggl: '/icons/toggl.png',
  boldsign: '/icons/boldsign.png',
  expo: {
    light: '/icons/expo.png',
    dark: '/icons/expo-light.png'
  },
  heygen: '/icons/heygen.png',
  luma: '/icons/luma.png',
  stedi: '/icons/stedi.png',
  acuity_scheduling: '/icons/acuity_scheduling.png',
  smartsheet: {
    light: '/icons/smartsheet.png',
    dark: '/icons/smartsheet-light.png'
  },
  vgs: '/icons/vgs.png',
  breezy_hr: '/icons/breezy_hr.png',
  firecrawl: '/icons/firecrawl.png',
  jfrog: '/icons/jfrog.png',
  cloudtalk: '/icons/cloudtalk.png',
  exa: '/icons/exa.png',
  waha: '/icons/waha.png',
  mautic: '/icons/mautic.png',
  yapily: '/icons/yapily.png',
  census: '/icons/census.png',
  firehydrant: '/icons/firehydrant.png',
  kombo: {
    light: '/icons/kombo.png',
    dark: '/icons/kombo-light.png'
  },
  granola: '/icons/granola.png',
  help_scout: '/icons/help_scout.png',
  check_hq: '/icons/check_hq.png',
  seatable: '/icons/seatable.png',
  ably: '/icons/ably.png',
  checkly: '/icons/checkly.png',
  flagsmith: '/icons/flagsmith.png',
  kustomer: '/icons/kustomer.png',
  kit: '/icons/kit.png',
  duffel: {
    light: '/icons/duffel.png',
    dark: '/icons/duffel-light.png'
  },
  taiga: '/icons/taiga.png',
  descope: '/icons/descope.png',
  fourthwall: '/icons/fourthwall.png',
  lago: '/icons/lago.png',
  sendcloud: '/icons/sendcloud.png',
  flexport: '/icons/flexport.png',
  circle: '/icons/circle.png',
  faundit: '/icons/faundit.png',
  chaindots: {
    dark: '/icons/chaindots-light.png',
    light: '/icons/chaindots.png'
  },
  shiphero: '/icons/shiphero.png',
  betteruptime: '/icons/betteruptime.png',
  uber: '/icons/uber.png',
  paystack: '/icons/paystack.png',
  alchemy: '/icons/alchemy.png',
  wechat: '/icons/wechat.png',
  fireflies: '/icons/fireflies.png',
  neon: '/icons/neon.svg',
  scrapfly: '/icons/scrapfly.png',
  affonso: '/icons/affonso.png',
  ardoq: '/icons/ardoq.png',
  bamboohr: '/icons/bamboohr.png',
  box: '/icons/box.png',
  breakcold: '/icons/breakcold.png',
  bugsmash: '/icons/bugsmash.png',
  campfire: '/icons/campfire.png',
  cashfree: '/icons/cashfree.png',
  charitystack: {
    light: '/icons/charitystack.png',
    dark: '/icons/charitystack-light.png'
  },
  chatim: '/icons/chatim.png',
  chili_piper: '/icons/chili_piper.png',
  coassemble: '/icons/coassemble.png',
  configcat: '/icons/configcat.png',
  cyera: '/icons/cyera.png',
  featurebase: '/icons/featurebase.png',
  greenshades: '/icons/greenshades.png',
  hume: '/icons/hume.png',
  infinite_giving: '/icons/infinite_giving.png',
  lob: '/icons/lob.png',
  lodgix: '/icons/lodgix.png',
  magic_hour: '/icons/magic_hour.png',
  metronome: '/icons/metronome.png',
  micetribe: '/icons/micetribe.png',
  onshape: '/icons/onshape.png',
  openrouter: '/icons/openrouter.png',
  paynow_gg: '/icons/paynow_gg.png',
  podium: '/icons/podium.png',
  purchasely: {
    light: '/icons/purchasely.png',
    dark: '/icons/purchasely-light.png'
  },
  quicknode: '/icons/quicknode.png',
  remote_com: '/icons/remote_com.png',
  schematic: '/icons/schematic.png',
  sent_dm: '/icons/sent_dm.png',
  sinch: '/icons/sinch.png',
  spherepay: '/icons/spherepay.png',
  spree: {
    light: '/icons/spree.png',
    dark: '/icons/spree-light.png'
  },
  tidio: {
    light: '/icons/tidio.png',
    dark: '/icons/tidio-light.png'
  },
  tiltify: {
    light: '/icons/tiltify.png',
    dark: '/icons/tiltify-light.png'
  },
  twenty: '/icons/twenty.png',
  typefully: '/icons/typefully.png',
  ultravox: '/icons/ultravox.png',
  upload_post: '/icons/upload_post.png',
  usesend: '/icons/usesend.png',
  vitable_health: '/icons/vitable_health.png',
  whoop: '/icons/whoop.png',
  greendot: '/icons/greendot.png',
  paymob: '/icons/paymob.png',
  ashby: '/icons/ashby.png',
  shipbob: '/icons/shipbob.png',
  incidentio: '/icons/incidentio.png',
  walmart: '/icons/walmart.png',
  absorb_lms: '/icons/absorb_lms.png',
  appstle: '/icons/appstle.png',
  folk: '/icons/folk.png',
  holded: '/icons/holded.png',
  nooks: '/icons/nooks.png',
  planning_center: '/icons/planning_center.png',
  semble: '/icons/semble.png',
  zigpoll: '/icons/zigpoll.png',
  athenahealth: '/icons/athenahealth.png',
  basin: '/icons/basin.png',
  dentally: '/icons/dentally.png',
  live_tennis_api: '/icons/live_tennis_api.png',
  pennylane: '/icons/pennylane.png',
  tremendous: '/icons/tremendous.png',
  agentcard: '/icons/agentcard.png',
  canny: '/icons/canny.png',
  fullenrich: '/icons/fullenrich.svg',
  humaans: '/icons/humaans.png',
  mailtrap: '/icons/mailtrap.png',
  teamwork: '/icons/teamwork.png',
  agentline: '/icons/agentline.png',
  autosana: '/icons/autosana.png',
  certn: '/icons/certn.png',
  envoy: '/icons/envoy.png',
  glean: '/icons/glean.png',
  huntress: '/icons/huntress.png',
  textus: '/icons/textus.png',
  vimeo: '/icons/vimeo.png',
  anarlog: '/icons/anarlog.png',
  autotask: '/icons/autotask.png',
  circleback: '/icons/circleback.png',
  hail: '/icons/hail.png',
  jazzhr: '/icons/jazzhr.png',
  missive: {
    light: '/icons/missive.png',
    dark: '/icons/missive-light.png'
  },
  pipeline_crm: '/icons/pipeline_crm.png',
  roam: '/icons/roam.png',
  theirstack: '/icons/theirstack.png',
  autumn: '/icons/autumn.png',
  companycam: '/icons/companycam.png',
  fiber_ai: '/icons/fiber_ai.png',
  hitpay: '/icons/hitpay.png',
  jobber: '/icons/jobber.png',
  moneybird: '/icons/moneybird.png',
  plain: '/icons/plain.png',
  rocketreach: '/icons/rocketreach.png',
  threads: '/icons/threads.png',
  zenefits: '/icons/zenefits.png',
  revolut: '/icons/revolut.png',
  retell: {
    dark: '/icons/retell-light.png',
    light: '/icons/retell.png'
  },
  shipstation: '/icons/shipstation.svg',
  bunny_stream: '/icons/bunny_stream.png',
  statsig: {
    dark: '/icons/statsig-light.png',
    light: '/icons/statsig.png'
  },
  attentive: '/icons/attentive.png',
  tikkie: '/icons/tikkie.svg',
  vapi: {
    light: '/icons/vapi.png',
    dark: '/icons/vapi-light.png'
  },
  volume: '/icons/volume.png',
  cloudinary: '/icons/cloudinary.svg',
  baselinker: '/icons/baselinker.png',
  aircall: '/icons/aircall.png',
  community: '/icons/community.png',
  azure_event_grid: '/icons/azure_event_grid.svg',
  cronofy: '/icons/cronofy.png',
  mailersend: '/icons/mailersend.png',
  formstack: '/icons/formstack.png',
  emporix: '/icons/emporix.png',
  cover_genius: '/icons/cover_genius.png',
  honeybadger: '/icons/honeybadger.png',
  middesk: '/icons/middesk.png',
  oncehub: '/icons/oncehub.png',
  salesloft: '/icons/salesloft.png',
  trigger_dev: '/icons/trigger_dev.png',
  assemblyai: '/icons/assemblyai.png',
  foursquare: '/icons/foursquare.png',
  cartesia: '/icons/cartesia.png',
  increase: '/icons/increase.png',
  mistral: '/icons/mistral.png',
  outreach: '/icons/outreach.png',
  savvycal: '/icons/savvycal.png',
  stigg: '/icons/stigg.png',
  unit: '/icons/unit.png',
  workable: '/icons/workable.png',
  lokalise: '/icons/lokalise.png',
  confluence: '/icons/confluence.png',
  paysafe: '/icons/paysafe.png',
  sendbird: '/icons/sendbird.png',
  storyblok: {
    light: '/icons/storyblok.png',
    dark: '/icons/storyblok-light.png'
  },
  wave: '/icons/wave.png',
  truework: {
    light: '/icons/truework.png',
    dark: '/icons/truework-light.png'
  },
  documenso: {
    light: '/icons/documenso.png',
    dark: '/icons/documenso-light.png'
  },
  moonpay: '/icons/moonpay.png',
  posthog: '/icons/posthog.png',
  shopware: '/icons/shopware.png',
  stream: '/icons/stream.png',
  xendit: '/icons/xendit.png',
  medusa: {
    light: '/icons/medusa.png',
    dark: '/icons/medusa-light.png'
  },
  northflank: '/icons/northflank.png',
  printify: '/icons/printify.png',
  shortcut: '/icons/shortcut.png',
  tawk_to: '/icons/tawk_to.png',
  yousign: '/icons/yousign.png',
  coterie: '/icons/coterie.png',
  footprint: '/icons/footprint.png',
  mercury: {
    light: '/icons/mercury.png',
    dark: '/icons/mercury-light.png'
  },
  recruitee: '/icons/recruitee.png',
  signnow: '/icons/signnow.png',
  todoist: '/icons/todoist.png',
  zoho_sign: '/icons/zoho_sign.png',
  quo: '/icons/quo.png',
  aftership: '/icons/aftership.svg',
  auth0: {
    light: '/icons/auth0.svg',
    dark: '/icons/auth0-light.svg'
  },
  bitbucket: '/icons/bitbucket.svg',
  calendly: '/icons/calendly.svg',
  checkout_com: '/icons/checkout_com.png',
  circleci: {
    light: '/icons/circleci.png',
    dark: '/icons/circleci-light.png'
  },
  clerk: {
    light: '/icons/clerk.png',
    dark: '/icons/clerk-light.png'
  },
  deepgram: {
    light: '/icons/deepgram.png',
    dark: '/icons/deepgram-light.png'
  },
  docker_hub: {
    light: '/icons/docker_hub.png',
    dark: '/icons/docker_hub-light.png'
  },
  needle: '/icons/needle.png',
  act_on: '/icons/act_on.png',
  ukg_ready: '/icons/ukg_ready.png',
  ampersand: '/icons/ampersand.png',
  egnyte: '/icons/egnyte.png',
  beehiiv: '/icons/beehiiv.png',
  youmail: '/icons/youmail.png',
  ingenious_build: '/icons/ingenious_build.png',
  simpro: '/icons/simpro.png',
  safebase: {
    dark: '/icons/safebase-light.png',
    light: '/icons/safebase.png'
  },
  knowbe4: '/icons/knowbe4.png',
  tanium: '/icons/tanium.png',
  sap_successfactors: '/icons/sap_successfactors.png',
  timify: '/icons/timify.png',
  webinarjam: {
    dark: '/icons/webinarjam-light.png',
    light: '/icons/webinarjam.png'
  },
  emarsys: '/icons/emarsys.png',
  lumos: '/icons/lumos.png',
  grafana: '/icons/grafana.svg',
  hugging_face: '/icons/hugging_face.png',
  jira: '/icons/jira.svg',
  klaviyo: {
    light: '/icons/klaviyo.png',
    dark: '/icons/klaviyo-light.png'
  },
  knock: {
    light: '/icons/knock.svg',
    dark: '/icons/knock-light.svg'
  },
  mollie: {
    light: '/icons/mollie.png',
    dark: '/icons/mollie-light.png'
  },
  onfido: '/icons/onfido.png',
  dwolla: '/icons/dwolla.png',
  didit: '/icons/didit.png',
  pusher: '/icons/pusher.png',
  launchdarkly: {
    light: '/icons/launchdarkly.png',
    dark: '/icons/launchdarkly-light.png'
  },
  veriff: {
    light: '/icons/veriff.png',
    dark: '/icons/veriff-light.png'
  },
  zernio: '/icons/zernio.png',
  mongodb_atlas: '/icons/mongodb_atlas.png',
  tailscale: '/icons/tailscale.png',
  heroku: '/icons/heroku.png',
  maxio: '/icons/maxio.png',
  rutter: '/icons/rutter.png',
  bolt_checkout: {
    light: '/icons/bolt_checkout.png',
    dark: '/icons/bolt_checkout-light.png'
  },
  signal_sciences: '/icons/signal_sciences.png',
  maintainx: {
    light: '/icons/maintainx.png',
    dark: '/icons/maintainx-light.png'
  },
  callrail: '/icons/callrail.png',
  lemon_squeezy: '/icons/lemon_squeezy.png',
  modern_treasury: '/icons/modern_treasury.png',
  castle: '/icons/castle.png',
  hibob: '/icons/hibob.png',
  motive: '/icons/motive.png',
  dbt_cloud: '/icons/dbt_cloud.png',
  fivetran: '/icons/fivetran.png',
  webex: '/icons/webex.png',
  ramp: '/icons/ramp.png',
  buildkite: '/icons/buildkite.png',
  dropbox: '/icons/dropbox.png',
  stytch: '/icons/stytch.png',
  daytona: '/icons/daytona.png',
  gopuff: '/icons/gopuff.png',
  whop: '/icons/whop.png',
  cloudflare: '/icons/cloudflare.png',
  marketo: '/icons/marketo.png',
  ninjaone: '/icons/ninjaone.png',
  mailjet: '/icons/mailjet.png',
  gravity_forms: '/icons/gravity_forms.png',
  zoominfo: '/icons/zoominfo.png',
  unipile: '/icons/unipile.png',
  mailparser: '/icons/mailparser.png',
  helius: '/icons/helius.png',
  databricks: '/icons/databricks.png',
  appsflyer: '/icons/appsflyer.png',
  asaas: '/icons/asaas.png',
  openclaw: '/icons/openclaw.png',
  microsoft_dynamics: '/icons/microsoft_dynamics.png',
  drata: '/icons/drata.png',
  notion: {
    light: '/icons/notion.png',
    dark: '/icons/notion-light.png'
  },
  ordinal: {
    light: '/icons/ordinal.png',
    dark: '/icons/ordinal-light.png'
  },
  eight_x_eight: '/icons/eight_x_eight.png',
  axiom: '/icons/axiom.png',
  cloudentity: '/icons/cloudentity.png',
  grist: '/icons/grist.png',
  metabase: '/icons/metabase.png',
  procore: {
    light: '/icons/procore.png',
    dark: '/icons/procore-light.png'
  },
  roller: '/icons/roller.png',
  torii: '/icons/torii.png',
  acumatica: '/icons/acumatica.png',
  baserow: '/icons/baserow.png',
  dynatrace: '/icons/dynatrace.png',
  halo_psa: '/icons/halo_psa.png',
  lessonly: '/icons/lessonly.png',
  pax8: {
    light: '/icons/pax8.png',
    dark: '/icons/pax8-light.png'
  },
  bitdefender: '/icons/bitdefender.png',
  cyberimpact: {
    light: '/icons/cyberimpact.png',
    dark: '/icons/cyberimpact-light.png'
  },
  factorial: '/icons/factorial.png',
  nextcloud: '/icons/nextcloud.png',
  quickbase: {
    light: '/icons/quickbase.svg',
    dark: '/icons/quickbase-light.svg'
  },
  aimfox: '/icons/aimfox.png',
  cin7_core: '/icons/cin7_core.png',
  datto_rmm: '/icons/datto_rmm.png',
  firstbase: '/icons/firstbase.svg',
  jamf_pro: '/icons/jamf_pro.png',
  nexthink: '/icons/nexthink.png',
  people_data_labs: '/icons/people_data_labs.png',
  rapidapi: '/icons/rapidapi.png',
  tripletex: {
    light: '/icons/tripletex.png',
    dark: '/icons/tripletex-light.png'
  },
  demodesk: '/icons/demodesk.png',
  jamie: '/icons/jamie.svg',
  maximizer: '/icons/maximizer.png',
  pingone: '/icons/pingone.png',
  redo: '/icons/redo.png',
  streak: '/icons/streak.png',
  videoask: '/icons/videoask.png',
  auvik: '/icons/auvik.png',
  clickhouse: '/icons/clickhouse.png',
  document360: '/icons/document360.png',
  jobadder: '/icons/jobadder.png',
  meilisearch: '/icons/meilisearch.png',
  postscript: '/icons/postscript.png',
  rocketlane: '/icons/rocketlane.png',
  swoogo: '/icons/swoogo.png',
  wiza: '/icons/wiza.png',
  pagerduty: '/icons/pagerduty.svg',
  snipcart: '/icons/snipcart.png',
  sparkpost: '/icons/sparkpost.png',
  supabase: '/icons/supabase.svg',
  revenuecat: '/icons/revenuecat.png',
  pipedream: '/icons/pipedream.png',
  telegram: '/icons/telegram.svg',
  recall_ai: '/icons/recall_ai.png',
  fathom: '/icons/fathom.png',
  pleo: '/icons/pleo.png',
  browserbase: '/icons/browserbase.png',
  yoco: '/icons/yoco.png',
  nash: '/icons/nash.png',
  vanta: '/icons/vanta.png',
  guesty: {
    light: '/icons/guesty.png',
    dark: '/icons/guesty-light.png'
  },
  ada: '/icons/ada.png',
  agentmail: '/icons/agentmail.png',
  crusoe: '/icons/crusoe.png',
  loop: '/icons/loop.png',
  openmeter: '/icons/openmeter.png',
  sendoso: '/icons/sendoso.png',
  sovos: '/icons/sovos.png',
  stitch_money: {
    light: '/icons/stitch_money.png',
    dark: '/icons/stitch_money-light.png'
  },
  taskrabbit: {
    light: '/icons/taskrabbit.png',
    dark: '/icons/taskrabbit-light.png'
  },
  uphold: '/icons/uphold.svg',
  wetravel: '/icons/wetravel.png',
  nango: '/icons/nango.png',
  segment: '/icons/segment.png',
  n8n: '/icons/n8n.png',
  zapier: '/icons/zapier.png',
  azure_logic_apps: '/icons/azure_logic_apps.svg',
  brevo: '/icons/brevo.png',
  gorgias: '/icons/gorgias.png',
  green_api: '/icons/green_api.png',
  freshdesk: '/icons/freshdesk.png',
  fillout: '/icons/fillout.png',
  instantly: '/icons/instantly.png',
  dealhub: '/icons/dealhub.png',
  rubrik: '/icons/rubrik.png',
  google_workspace: '/icons/google_workspace.png',
  webflow: '/icons/webflow.png',
  wordpress_com: '/icons/wordpress_com.png',
  mcp_events: {
    light: '/icons/mcp_events.svg',
    dark: '/icons/mcp_events-light.svg'
  },
  polytomic: '/icons/polytomic.png',
  fanvue: '/icons/fanvue.png',
  onfleet: '/icons/onfleet.png',
  whatnot: '/icons/whatnot.png',
  quickbooks: '/icons/quickbooks.png',
  attio: {
    light: '/icons/attio.png',
    dark: '/icons/attio-light.png'
  },
  line: '/icons/line.png',
  clickup: '/icons/clickup.png',
  calcom: '/icons/calcom.png',
  sumsub: '/icons/sumsub.png',
  mux: '/icons/mux.png',
  shippo: '/icons/shippo.png',
  etsy: '/icons/etsy.png',
  reducto: '/icons/reducto.png',
  deck: '/icons/deck.png',
  scaleway: '/icons/scaleway.svg',
  modem_pay: '/icons/modem_pay.png',
  bitculator: '/icons/bitculator.svg',
  better_stack: '/icons/better_stack.png',
  papergames: {
    light: '/icons/papergames.svg',
    dark: '/icons/papergames-light.svg'
  }
};
export const material_icon_mapping = {
  retry: 'replay',
  manual: 'pan_tool_alt',
  success: 'check_circle',
  error: 'report',
  info: 'info',
  warning: 'warning',
  close: 'close',
  connections: 'account_tree',
  issues: 'inbox',
  metrics: 'insert_chart',
  leave: 'exit_to_app',
  bookmarks: 'bookmarks',
  help: 'contact_support',
  docs: 'description',
  upgrade: 'ambient_screen',
  expand_more: 'expand_more',
  expand_less: 'expand_less',
  terminal: 'terminal',
  local: 'terminal_2',
  flow: 'automation',
  http: 'language',
  settings: 'settings',
  add: 'add',
  add_circle: 'add_circle',
  export_notes: 'export_notes',
  export: 'ios_share',
  check: 'check',
  chat: 'mark_unread_chat_alt',
  email: 'forward_to_inbox',
  new_releases: 'award_star',
  changelog: 'rss_feed',
  chevron_left: 'chevron_left',
  chevron_up: 'keyboard_arrow_up',
  chevron_down: 'keyboard_arrow_down',
  wallet: 'wallet',
  key: 'key',
  group: 'group',
  tune: 'tune',
  account: 'account_circle',
  save: 'save',
  view: 'visibility',
  dismiss: 'visibility_off',
  link: 'arrow_outward',
  connect: 'power',
  disconnect: 'power_off',
  delete: 'delete',
  copy: 'content_copy',
  copy_all: 'copy_all',
  roll: 'flip_camera_android',
  edit: 'edit',
  checklist: 'checklist',
  plans: 'checklist',
  sort: 'swap_vert',
  filter: 'filter_alt',
  filter_list: 'filter_list',
  open: 'open_in_full',
  notification: 'notifications_active',
  notification_off: 'notifications_off',
  arrow_downward: 'arrow_downward',
  arrow_upward: 'arrow_upward',
  inbox: 'inbox',
  send: 'send',
  transformation: 'flip',
  swap: 'swap_horiz',
  rate_limit: 'readiness_score',
  done_all: 'done_all',
  remove_done: 'remove_done',
  awknowledged: 'mystery',
  history: 'history',
  visibility: 'visibility',
  issue_trigger: 'destruction',
  cancel: 'cancel',
  refresh: 'source_notes',
  reload: 'refresh',
  date: 'calendar_month',
  notes: 'notes',
  keyboard: 'keyboard',
  data_object: 'data_object',
  arrow_forward: 'arrow_forward',
  rotate_left: 'rotate_left',
  chevron_right: 'chevron_right',
  subdirectory: 'subdirectory_arrow_right',
  block: 'block',
  autorenew: 'autorenew',
  source: 'send_money',
  status: 'bolt',
  search: 'search',
  logout: 'logout',
  dark_mode: 'dark_mode',
  light_mode: 'light_mode',
  vertical_more: 'more_vert',
  horizontal_more: 'more_horiz',
  arrow_drop_up: 'arrow_drop_up',
  arrow_drop_down: 'arrow_drop_down',
  arrow_right: 'arrow_right',
  visibility_off: 'visibility_off',
  expand_all: 'expand_all',
  collapse_all: 'collapse_all',
  destinations: 'my_location',
  destination: 'target',
  environment: 'deployed_code',
  inspect: 'frame_inspect',
  test: 'science',
  person: 'person',
  bookmark_add: 'bookmark_add',
  bookmark_remove: 'bookmark_remove',
  bookmark: 'bookmark',
  replay: 'autoplay',
  schedule: 'chronic',
  pause_circle: 'pause_circle',
  play_circle: 'play_circle',
  disable: 'do_not_disturb_on',
  enable: 'power_settings_new',
  inventory: 'inventory_2',
  verification: 'verified_user',
  api: 'api',
  rule: 'rule',
  document: 'description',
  change: 'flip_camera_android',
  auto_awesome: 'auto_awesome',
  clear: 'delete_sweep',
  lock: 'lock',
  gavel: 'gavel',
  edit_square: 'edit_square',
  success_circle: 'check_circle',
  download: 'download',
  undo: 'undo',
  deduplicate: 'tab_inactive',
  plagiarism: 'plagiarism',
  right_panel_close: 'right_panel_close',
  left_panel_close: 'left_panel_close',
  left_panel_open: 'left_panel_open',
  folder: 'folder',
  transfer: 'local_shipping',
  construction: 'construction',
  progress_activity: 'progress_activity',
  throughput: 'earthquake',
  code: 'code',
  grid_view: 'grid_view',
  bolt: 'bolt',
  computer: 'computer',
  backpressure: 'speed',
  attempt: 'step',
  arrow_dotted_down: 'arrow_cool_down',
  arrow_dotted_up: 'arrow_warm_up',
  signature: 'signature',
  webhook: 'webhook',
  table: 'table',
  drag_indicator: 'drag_indicator',
  avg_pace: 'avg_pace',
  arrow_back: 'arrow_back',
  add_column_right: 'add_column_right',
  portal: 'captive_portal',
  login: 'login',
  keyboard_return: 'keyboard_return',
  cached: 'cached',
  redirect: 'call_split'
};
function InvertIcon(t0) {
  const $ = _c(3);
  const {
    icon
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      filter: "invert(1)",
      height: "100%",
      display: "flex",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== icon) {
    t2 = <div style={t1}>{icon}</div>;
    $[1] = icon;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export const platforms_icons_mapping = {
  agent: {
    light: AgentIcon
  },
  request_link: {
    light: RequestLinkIcon
  },
  requests: {
    light: RequestLightIcon
  },
  arrow_in: {
    light: ArrowInIcon
  },
  events: {
    light: EventsLightIcon
  },
  '3dEye': {
    light: ThreeDEyeLightIcon,
    dark: ThreeDEyeDarkIcon
  },
  adyen: {
    light: AdyenLightIcon
  },
  airwallex: {
    light: AirwallexLightIcon
  },
  claude: {
    light: ClaudeLightIcon
  },
  ascend: {
    light: AscendLightIcon,
    dark: AscendDarkIcon
  },
  akeneo: {
    light: AkeneoLightIcon
  },
  awssns: {
    light: AWSSNSLightIcon
  },
  awssqs: {
    light: AWSSQSLightIcon
  },
  awss3: {
    light: AWSS3LightIcon
  },
  azure_servicebus: {
    light: AzureServiceBusLightIcon
  },
  bondsmith: {
    light: BondsmithLightIcon
  },
  cloudsignals: {
    light: CloudsignalsLightIcon
  },
  gcp_pubsub: {
    light: GCPPubSubLightIcon
  },
  gemini: {
    light: GeminiLightIcon,
    dark: GeminiDarkIcon
  },
  gocardless: {
    light: GocardlessLightIcon
  },
  commercelayer: {
    light: CommercelayerLightIcon,
    dark: () => <InvertIcon icon={<CommercelayerLightIcon />} />
  },
  courier: {
    light: CourierLightIcon
  },
  customerio: {
    light: CustomerioLightIcon
  },
  facebook: {
    light: FacebookLightIcon
  },
  fiserv: {
    light: FiservLightIcon
  },
  frontapp: {
    light: FrontappLightIcon
  },
  github: {
    light: () => <GitHubIcon mode="light" />,
    dark: () => <GitHubIcon mode="dark" />
  },
  gitlab: {
    light: GitLabLightIcon
  },
  hubspot: {
    light: HubSpotLightIcon
  },
  linear: {
    light: LinearLightIcon
  },
  mailgun: {
    light: MailgunLightIcon
  },
  oura: {
    light: OuraLightIcon,
    dark: () => <InvertIcon icon={<OuraLightIcon />} />
  },
  persona: {
    light: PersonaLightIcon
  },
  pipedrive: {
    light: PipedriveLightIcon
  },
  postmark: {
    light: PostmarkLightIcon
  },
  praxis: {
    light: PraxisLightIcon,
    dark: () => <InvertIcon icon={<PraxisLightIcon />} />
  },
  propertyfinder: {
    light: PropertyFinderLightIcon
  },
  pylon: {
    light: PylonLightIcon
  },
  rabbitmq: {
    light: RabbitMQLightIcon
  },
  razorpay: {
    light: RazorpayLightIcon
  },
  recharge: {
    light: RechargeLightIcon
  },
  repay: {
    light: RepayLightIcon
  },
  replicate: {
    light: ReplicateLightIcon,
    dark: () => <InvertIcon icon={<ReplicateLightIcon />} />
  },
  sanity: {
    light: SanityLightIcon
  },
  sendgrid: {
    light: SendgridLightIcon
  },
  shopline: {
    light: ShoplineLightIcon,
    dark: () => <InvertIcon icon={<ShoplineLightIcon />} />
  },
  slack: {
    light: SlackLightIcon
  },
  smartcar: {
    light: SmartcarLightIcon,
    dark: SmartcarDarkIcon
  },
  solidgate: {
    light: SolidgateLightIcon
  },
  square: {
    light: SquareLightIcon,
    dark: () => <InvertIcon icon={<SquareLightIcon />} />
  },
  stripe: {
    light: StripeLightIcon
  },
  svix: {
    light: SvixLightIcon
  },
  synctera: {
    light: SyncteraLightIcon
  },
  tebex: {
    light: TebexLightIcon
  },
  telnyx: {
    light: TelnyxLightIcon
  },
  tiktok: {
    light: TikTokLightIcon,
    dark: () => <InvertIcon icon={<TikTokLightIcon />} />
  },
  tiktokshop: {
    light: TikTokShopLightIcon,
    dark: () => <InvertIcon icon={<TikTokShopLightIcon />} />
  },
  tokenio: {
    light: TokenioLightIcon,
    dark: () => <InvertIcon icon={<TokenioLightIcon />} />
  },
  treezor: {
    light: TreezorLightIcon
  },
  twitch: {
    light: TwitchLightIcon
  },
  vercel: {
    light: VercelLightIcon,
    dark: () => <InvertIcon icon={<VercelLightIcon />} />
  },
  whatsapp: {
    light: WhatsAppLightIcon
  },
  wix: {
    light: WixLightIcon,
    dark: () => <InvertIcon icon={<WixLightIcon />} />
  },
  x: {
    light: XLightIcon,
    dark: () => <InvertIcon icon={<XLightIcon />} />
  },
  zendesk: {
    light: ZendeskLightIcon,
    dark: ZendeskDarkIcon
  }
};
export type IconName = keyof typeof svg_icons | keyof typeof material_icon_mapping | keyof typeof platforms_icons_mapping | keyof typeof public_icons;
export interface IconTheme {
  primary?: boolean;
  danger?: boolean;
  warning?: boolean;
  success?: boolean;
  dark?: boolean;
  muted?: boolean;
  light?: boolean;
  neutral?: boolean;
  disabled?: boolean;
}
interface Props extends Pick<StyledUtilsProps, 'p' | 'm' | 'style'>, ComponentProps<typeof Div>, IconTheme {
  icon?: IconName;
  src?: string;
  large?: boolean;
  small?: boolean; // Default size

  left?: boolean | SpacingGridMultiple | number;
  right?: boolean | SpacingGridMultiple | number;
  pointer?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

/** Styling-only flags; must not become DOM attributes on svg/img/span (invalid HTML + SSR/CSR mismatches). */
const ICON_STYLED_PROP_KEYS = new Set(['muted', 'primary', 'danger', 'warning', 'success', 'dark', 'light', 'neutral', 'disabled', 'large', 'small', 'left', 'right', 'pointer', 'rounded', 'is_platform']);
export const StyledIcon = styled(Div).withConfig({
  // styled-components v6: the 2nd arg is now the target element, not a default
  // validator fn. `Div` is a custom component, so v5's default validator forwarded
  // everything here anyway — we just keep blocking the icon-specific styling props.
  shouldForwardProp: prop => !ICON_STYLED_PROP_KEYS.has(prop as string)
})<Props & {
  rounded?: boolean;
  is_platform?: boolean;
}>(({
  theme,
  rounded,
  is_platform,
  ...props
}) => css`
    color: currentColor;
    fill: ${is_platform ? 'unset' : 'currentColor'};
    vertical-align: sub;
    flex: none;
    text-align: center;
    ${props.pointer && css`
      cursor: pointer;
    `}

    ${rounded && css`
      border-radius: ${theme.pxToRem(2)};
      overflow: hidden;
    `}

    ${theme.optionsToCss({
  large: css`
          height: ${theme.pxToRem(24)};
          width: ${theme.pxToRem(24)};
          font-size: ${theme.pxToRem(24)} !important;
          font-variation-settings:
            'FILL' 0,
            'wght' 400,
            'GRAD' 0,
            'opsz' 24;
        `,
  small: css`
          height: ${theme.pxToRem(16)};
          width: ${theme.pxToRem(16)};
          font-size: ${theme.pxToRem(16)} !important;
          font-variation-settings:
            'FILL' 0,
            'wght' 400,
            'GRAD' 0,
            'opsz' 20;
        `
}, props, 'small')}

    ${theme.optionsToCss({
  muted: css`
          color: ${theme.colors.on.neutral.tertiary_neutral} !important;
        `,
  primary: css`
          color: ${theme.colors.on.hue_container.primary} !important;
        `,
  warning: css`
          color: ${theme.colors.on.hue_container.warning} !important;
        `,
  danger: css`
          color: ${theme.colors.on.hue_container.danger} !important;
        `,
  success: css`
          color: ${theme.colors.on.hue_container.success} !important;
        `,
  dark: css`
          color: ${theme.colors.on.neutral.primary_neutral} !important;
        `,
  neutral: css`
          color: ${theme.colors.on.neutral.secondary_neutral} !important;
        `,
  disabled: css`
          color: ${theme.colors.on.neutral.disabled} !important;
        `
}, props)}

    ${props.right && css`
      margin-left: ${theme.spacing(typeof props.right === 'number' ? props.right as SpacingGridMultiple : 2)};
    `}
    ${props.left && css`
      margin-right: ${theme.spacing(typeof props.left === 'number' ? props.left as SpacingGridMultiple : 2)};
    `}
  `);
const Icon = t0 => {
  const $ = _c(24);
  let icon;
  let props;
  if ($[0] !== t0) {
    ({
      icon,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = icon;
    $[2] = props;
  } else {
    icon = $[1];
    props = $[2];
  }
  const theme = useTheme();
  if (!icon) {
    let t1;
    if ($[3] !== props) {
      t1 = <StyledIcon as="img" {...props} />;
      $[3] = props;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  if (platforms_icons_mapping[icon]) {
    const PlatformIcon = theme.mode === "dark" && platforms_icons_mapping[icon].dark ? platforms_icons_mapping[icon].dark : platforms_icons_mapping[icon].light || platforms_icons_mapping[icon];
    let t1;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        align: "center",
        justify: "center"
      };
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    let t2;
    if ($[6] !== PlatformIcon) {
      t2 = <PlatformIcon />;
      $[6] = PlatformIcon;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    let t3;
    if ($[8] !== props || $[9] !== t2) {
      t3 = <StyledIcon {...props} is_platform={true} as="span" rounded={true} flex={t1}>{t2}</StyledIcon>;
      $[8] = props;
      $[9] = t2;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    return t3;
  }
  if (material_icon_mapping[icon]) {
    const t1 = material_icon_mapping[icon];
    let t2;
    if ($[11] !== props || $[12] !== t1) {
      t2 = <StyledIcon {...props} as="span" className="material-symbols-rounded">{t1}</StyledIcon>;
      $[11] = props;
      $[12] = t1;
      $[13] = t2;
    } else {
      t2 = $[13];
    }
    return t2;
  }
  const public_icon = public_icons[icon];
  if (public_icon) {
    const src = typeof public_icon === "string" ? public_icon : public_icon[theme.mode] || public_icon.light || public_icon;
    let t1;
    if ($[14] !== icon || $[15] !== props || $[16] !== src) {
      t1 = <StyledIcon {...props} as="img" rounded={true} src={src} alt={icon} />;
      $[14] = icon;
      $[15] = props;
      $[16] = src;
      $[17] = t1;
    } else {
      t1 = $[17];
    }
    return t1;
  }
  let t1;
  if ($[18] !== icon || $[19] !== theme) {
    t1 = svg_icons[icon] && svg_icons[icon]({
      theme
    });
    $[18] = icon;
    $[19] = theme;
    $[20] = t1;
  } else {
    t1 = $[20];
  }
  let t2;
  if ($[21] !== props || $[22] !== t1) {
    t2 = <StyledIcon {...props} as="svg" viewBox="0 0 24 24">{t1}</StyledIcon>;
    $[21] = props;
    $[22] = t1;
    $[23] = t2;
  } else {
    t2 = $[23];
  }
  return t2;
};
export default Icon;